export default __webpack_public_path__ + "static/media/aws-solution-architect.5de5ac50.png";